<!-- Uploaded Files Grid Component -->
<div class="uploaded-files-grid-container">
  <!-- Country Warning Banner -->
  <div class="warning-banner">
    <div class="warning-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2">
        <path
          d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
        <line x1="12" y1="9" x2="12" y2="13"></line>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
    </div>
    <p class="warning-text">{{ countryWarningText }}</p>
  </div>

  <!-- Grid Table -->
  @if (hasData) {
    <div class="grid-wrapper">
      <table class="data-grid">
        <thead>
          <tr>
            @for (column of columns; track column.field) {
              <th [class]="'col-' + column.type">{{ column.header }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (file of parsedFiles; track trackByFileId($index, file)) {
            <tr>
              @for (column of columns; track column.field) {
                <td [class]="'col-' + column.type">
                  @switch (column.type) {
                    @case ('text') {
                      {{ getCellValue(file, column) }}
                    }
                    @case ('number') {
                      {{ getNumericCellValue(file, column) | number }}
                    }
                    @case ('currency') {
                      {{
                        getNumericCellValue(file, column)
                          | currency: 'USD' : 'symbol' : '1.2-2'
                      }}
                    }
                    @case ('status') {
                      @if (file.uploadStatus === UploadStatus.Uploading) {
                        <ukg-progress-linear
                          class="file-upload-progress"
                          no-check
                          indeterminate></ukg-progress-linear>
                      } @else {
                        <span
                          class="status-badge"
                          [ngClass]="getStatusClass(file.uploadStatus)">
                          {{ file.uploadStatus }}
                        </span>
                      }
                    }
                    @case ('action') {
                      <button
                        type="button"
                        class="btn btn-link remove-btn"
                        (click)="onRemoveFile(file.fileId)"
                        title="Remove file">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2">
                          <polyline points="3 6 5 6 21 6"></polyline>
                          <path
                            d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                          <line x1="10" y1="11" x2="10" y2="17"></line>
                          <line x1="14" y1="11" x2="14" y2="17"></line>
                        </svg>
                        Remove
                      </button>
                    }
                  }
                </td>
              }
            </tr>
          }
        </tbody>
        <!-- Footer Row with Totals -->
        <tfoot>
          <tr class="totals-row">
            @for (column of columns; track column.field) {
              <td [class]="'col-' + column.type">
                @if (column.field === 'fileName') {
                  <strong>Totals</strong>
                } @else if (column.showTotal) {
                  @if (column.type === 'currency') {
                    <strong>{{
                      getTotalForColumn(column)
                        | currency: 'USD' : 'symbol' : '1.2-2'
                    }}</strong>
                  } @else {
                    <strong>{{ getTotalForColumn(column) | number }}</strong>
                  }
                }
              </td>
            }
          </tr>
        </tfoot>
      </table>
    </div>
  } @else {
    <!-- Empty State -->
    <div class="empty-state">
      <div class="empty-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5">
          <path
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
        </svg>
      </div>
      <p class="empty-text">No files uploaded yet</p>
      <p class="empty-subtext">
        Upload files using the drop zone above to see them here
      </p>
    </div>
  }
</div>
